<script>
  import { Upload, UserRound } from 'lucide-svelte';
  import { avatarContentUrl } from '$lib/avatar';
  import SettingsCard from '../shared/SettingsCard.svelte';

  export let form;
  export let avatarPreview = '';
  export let uploadingAvatar = false;
  export let onUploadAvatar = () => {};

  let failedAvatarUrl = '';

  function previewAvatarUrl(value) {
    const preview = String(value || '').trim();
    if (preview.startsWith('blob:') || preview.startsWith('data:image/')) return preview;
    return avatarContentUrl(preview);
  }

  // Preview may be a temporary blob URL or the relative API URL returned by upload.
  // Both must be displayable before the settings screen is opened again.
  $: currentAvatarUrl = previewAvatarUrl(avatarPreview) || avatarContentUrl(form?.avatar);
  $: if (failedAvatarUrl && failedAvatarUrl !== currentAvatarUrl) {
    failedAvatarUrl = '';
  }

  function markAvatarUnavailable() {
    failedAvatarUrl = currentAvatarUrl;
  }
</script>

<SettingsCard title="Account Overview" description="Primary identity and sign-in metadata.">
  <div class="flex flex-col items-center text-center">
    <div class="flex h-36 w-36 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100 shadow-sm sm:h-40 sm:w-40">
      {#if currentAvatarUrl && failedAvatarUrl !== currentAvatarUrl}
        <img
          src={currentAvatarUrl}
          alt={form.name || 'Avatar'}
          class="h-full w-full object-cover"
          decoding="async"
          onerror={markAvatarUnavailable} />
      {:else}
        <UserRound size={56} class="text-slate-400" />
      {/if}
    </div>

    <label
      class="mt-4 inline-flex h-10 items-center gap-2 rounded-xl border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm transition hover:bg-slate-50 focus-within:ring-2 focus-within:ring-blue-100 {uploadingAvatar ? 'cursor-wait opacity-60' : 'cursor-pointer'}">
      <Upload size={16} />
      {uploadingAvatar ? 'Uploading...' : 'Upload Avatar'}
      <input type="file" accept="image/jpeg,image/png,image/webp" class="sr-only" disabled={uploadingAvatar} onchange={onUploadAvatar} />
    </label>

    <div class="mt-5 min-w-0">
      <h3 class="truncate text-lg font-semibold text-slate-900">{form.name}</h3>
      <p class="mt-1 truncate text-sm text-slate-500">{form.email}</p>
    </div>
  </div>

  <dl class="mt-6 space-y-4 border-t border-slate-200 pt-5">
    <div class="flex items-center justify-between gap-4">
      <dt class="text-sm text-slate-500">Status</dt>
      <dd class="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">{form.status}</dd>
    </div>

    <div class="flex items-center justify-between gap-4">
      <dt class="text-sm text-slate-500">Provider</dt>
      <dd class="truncate text-sm font-medium text-slate-700">{form.provider}</dd>
    </div>

    <div class="flex items-center justify-between gap-4">
      <dt class="text-sm text-slate-500">Last Login</dt>
      <dd class="truncate text-sm text-slate-700">{form.lastLogin}</dd>
    </div>
  </dl>
</SettingsCard>
